const _ = require('lodash')
const {post} = require('@/service/AxiosService')
const store = require('@/store/index.js')
/** サーバ側に送信するまでの間隔 */
const SERVER_SEND_INTERVAL_M_SEC = 5000
/** サーバ側に送信する対象のログレベル */
const SERVER_SEND_LOGLEVEL = ['warn', 'error']
/** 最大ログスタック数 */
const MAX_LOG_STACK_SIZE = 100

const EMPTY = 0
/**
 * ログ収集処理
 * @param {Object} logger logLevelモジュール
 * @param {Object} options 設定値
 * @param {Boolean} options.isOutputConsole コンソールログ出力するかどうか
 * @param {String} options.level 適用するログレベル
 */
const logCollectionProcess = async function (logger, options) {
  if (!logger || !logger.methodFactory)
    throw new Error(
      'loglevel instance has to be specified in order to be extended'
    )

  var _logger = logger
  var _isOutputConsole = (options && options.isOutputConsole) || false
  var _level = (options && options.level) || _logger.levels.WARN
  var _originalFactory = _logger.methodFactory
  var _logStack = []

  /** 出力ログ解析処理 */
  _logger.methodFactory = function (methodName, logLevel) {
    var rawMethod = _originalFactory(methodName, logLevel)

    return function () {
      // コンソール出力が有効の場合、ログ出力
      if (_isOutputConsole) rawMethod.apply(null, arguments)

      // 指定のログ以外は収集しない
      if (!SERVER_SEND_LOGLEVEL.includes(methodName)) return

      var args = Array.prototype.slice.call(arguments, 0) // eslint-disable-line no-magic-numbers
      const messageIndex = 0 // ログの第一引数を抽出するインデックス
      const paramsIndex = 1 // ログの第二引数を抽出するインデックス
      const message = args[messageIndex]
      const params = args[paramsIndex]

      // ログ情報をスタック(上限までスタック可)
      _logStack = _logStack.slice(-MAX_LOG_STACK_SIZE)
      const stackInfo = generateLogStack(methodName, message, params)
      _logStack.push(stackInfo)

      _store()
    }
  }
  // ログレベルを設定
  _logger.setLevel(_level)

  /** ログ収集処理 */
  var _storeLogStack = async function _storeLogStack() {
    // 送信対象のログがスタックされていない場合は何もしない
    if (!_logStack.length) return

    try {
      // サーバにログをまとめて送信するため、ログを集約
      let logList = []
      while (_logStack.length > EMPTY) {
        const data = _logStack.shift()
        logList.push(data)
      }
      // サーバにログ送信
      sendLog(logList)
    } catch (ex) {
      // 送信失敗した場合は何もしない
      _logStack = []
    }
  }

  // 一定期間ログが出力されなければ、その間のログの内容を収集する
  var _store = _.debounce(_storeLogStack, SERVER_SEND_INTERVAL_M_SEC)
}

/**
 * スタックする情報を作成する
 * @param {String} methodName ログメソッド
 * @param {String} message ログメッセージ
 * @param {* | Error} params パラメータ
 * @returns 出力時間、アプリバージョン、ネイティブ情報、ログレベル、メッセージ、パラメータ
 */
function generateLogStack(methodName, message, params) {
  const nativeVersion =
    store?.default?.state?.nativeInfo?.version || 'ver未取得'
  return {
    time: new Date().toISOString(),
    appVersion: process.env.VUE_APP_PROJECT_VERSION,
    nativeVersion: nativeVersion,
    loglevel: methodName,
    message: methodName + ': ' + message,
    params:
      // ErrorオブジェクトはJSON.stringfy()ができないため、オブジェクトとして再設定する
      params instanceof Error
        ? {message: params.message, stack: params.stack, name: params.name}
        : params,
  }
}

/**
 * 収集ログ送信処理
 * @param {Array} logList 収集ログ
 */
function sendLog(logList) {
  if (logList.length === EMPTY) return

  post('receiveClientLogs', {logList: logList}, {}).catch(() => {}) // ログ送信に失敗した場合は、何も行わない。
}

module.exports = logCollectionProcess
